export function createStreamMessage({ index = 0, isHlsFormatIncorrect = false, isShoutcastHack = false, isFinalStream = false, removedM3UExtension = false, }) {
    const streamDetails = [`idx=${index}`];
    if (isHlsFormatIncorrect) {
        streamDetails.push('hlsFormatIncorrect');
    }
    if (removedM3UExtension) {
        streamDetails.push('m3uExtensionRemoved');
    }
    if (isShoutcastHack) {
        if (isFinalStream) {
            streamDetails.push('shoutcastHackExtraTime');
        }
        else {
            streamDetails.push('shoutcastHack');
        }
    }
    return streamDetails.join(':');
}
